module.exports = __webpack_public_path__ + "img/tyre_net_logo.6a7a5c31.png";